import { render, staticRenderFns } from "./NofiticationMonitor.vue?vue&type=template&id=33b6707b&scoped=true&"
import script from "./NofiticationMonitor.vue?vue&type=script&lang=ts&"
export * from "./NofiticationMonitor.vue?vue&type=script&lang=ts&"
import style0 from "./NofiticationMonitor.vue?vue&type=style&index=0&id=33b6707b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6707b",
  null
  
)

export default component.exports